export default process.env.NODE_ENV !== "production"
  ? // export default false
    {
      kyc_api_endpoint: "https://kyc.getcupi.com/api",
      // node_api_endpoint: "http://192.168.1.193:5050",
      // kyc_api_endpoint: "http://192.168.0.95:5051",
      // kyc_api_endpoint: "http://192.168.1.193:5051",
      cognito_client_id: "6oign0d7urm10jstpl9r9crt25",
      // Client_Id: "21k0cgope0hvi22dikd805pbes",
      Client_Id: "4l3pbm5skfdhs4ofn11afvgvi4",
      // cognito_client_id: "3g6r2ulh1m5jqisc8eajo47vv7",
    }
  : {
      node_api_endpoint: "http://192.168.1.193:5050",
      kyc_api_endpoint: "https://kyc.getcupi.com/api",
      cognito_client_id: "6oign0d7urm10jstpl9r9crt25",
      Client_Id: "21k0cgope0hvi22dikd805pbes",
    };
